module.exports = __webpack_public_path__ + "img/title_background.ab60c452.png";